import classNames from 'classnames';
import styles from './input.module.scss';
import {forwardRef} from 'react';
import {PlatformIntl} from 'src/infra/PlatformIntl';

interface TextareaInputProps {
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  name: string;
  rows?: number;
}

const intl = PlatformIntl.getInstance();


export const TextareaInput = forwardRef(({
  placeholder = intl.formatMessage('sharedTypeHere'),
  className,
  rows = 3,
  ...rest
}: TextareaInputProps, ref) => {
  return (
    <textarea
      // @ts-ignore
      ref={ref}
      className={classNames(styles.input, styles.textareaInput, styles.border, styles.spacing, className)}
      placeholder={placeholder}
      {...rest}
      rows={rows}
    />
  );
});
